import React, { Component } from 'react';
import $ from 'jquery/dist/jquery.min.js';
import PubSub from 'pubsub-js';

class FilterTag_API extends Component {
    constructor(props) {
        super(props);
        this.state = {
            FilterTagList: [],
            FilterMatchedTagList: [],
            loading: this.props.Loading
        }
        this.HandleRemoveTag = this.HandleRemoveTag.bind(this);
        this.handeChangefiltertag = this.handeChangefiltertag.bind(this);

    }
    componentDidMount(e) {
        if (this.props.FilterTags != null && this.props.FilterTags != '' && this.props.FilterTags != undefined && this.props.FilterTags != "null") {
            if (this.props.Roletype == "Admin") {
                this.BindFilteredTag(this.props.Roletype, this.props.dist_id, this.props.Rolename, this.props.wh_Id, this.props.df, this.props.dt, this.props.FilterTags);
            }
        }
    }

    componentDidUpdate(prevProp) {
        if ((prevProp.FilterTags != this.props.FilterTags && (this.props.FilterTags != null || this.props.FilterTags != '' || this.props.FilterTags != undefined || this.props.FilterTags != "null"))) {
            if (this.props.Roletype == "Admin") {
                this.setState({ FilterTagList: [] });
                this.BindFilteredTag(prevProp.Roletype, prevProp.dist_id, prevProp.Rolename, prevProp.wh_Id, prevProp.df, prevProp.dt, this.props.FilterTags);
            }
        }

    }

    BindFilteredTag(role, distributor_UserId, name, wholesalerid, datefrom, dateto, FilterJson) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'requestHeader': FilterJson, 'X-Browser-Url': window.location.href },
                body: JSON.stringify({ role, distributor_UserId, name, wholesalerid, datefrom, dateto })
            };
            return fetch(`/api/Filter/getFilterMatchingTag_AnalyticAPI`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        this.setState({ ...this.state, FilterTagList: JSON.parse(FilterJson), FilterMatchedTagList: apidata });
                    }
                    catch (error) {
                        try {
                            this.setState({ FilterTagList: FilterJson });
                            this.setState({ FilterMatchedTagList: apidata });
                        }
                        catch (error) {
                        }
                    }
                });
        }
        catch (error) {
        }
    }
    handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            return data;
        });
    }
    handeChangefiltertag(e) {
        this.setState({
            ...this.state,
            endDate: this.props.startDate,
            startDate: this.props.endDate,
            userdata: JSON.parse(localStorage.getItem('user'))
        });
        this.props.handeChangefiltertag(this.props.dashboardName, this.props.startDate, this.props.endDate);
    }

    HandleRemoveTag = e => {
        try {
            var CreatedJson = '';
            let dnodename = $(e.target).parent().attr('nodename');
            let dnodeval = $(e.target).parent().attr('nodevalue');

            //$('span[nodename="' + dnodename + '"][nodevalue="' + dnodeval + '"]').css('display', 'none');
            try {
                // $($(e.target).parent()).addClass('hide');
                let ExistJson = JSON.parse(localStorage.getItem('Advance_Filter_API'));
                CreatedJson = JSON.stringify(ExistJson);
                let ItemIndex = ExistJson[dnodename].indexOf(dnodeval);
                if (ItemIndex > -1) {
                    ExistJson[dnodename].splice(ItemIndex, 1);

                    if (ExistJson[dnodename].length == 0) {
                        delete ExistJson[dnodename]
                    }

                }
                else if (dnodename == "PhZip" || dnodename == "PrZip") {
                    let ItemIndex = ExistJson[dnodename].indexOf(dnodeval.replace('-', ''));
                    ExistJson[dnodename].splice(ItemIndex, 1);

                    if (ExistJson[dnodename].length == 0) {
                        delete ExistJson[dnodename]
                    }
                }
                try {
                    if (JSON.stringify(ExistJson) == "{}") {
                        localStorage.setItem('Advance_Filter_API', null);
                    }
                    else {
                        localStorage.setItem('Advance_Filter_API', JSON.stringify(ExistJson));
                    }
                    let newDate = new Date();
                    localStorage.setItem('Filter_Last_Update_Time_API', newDate);
                    localStorage.setItem('Updated_AdFilter_Status_API', CreatedJson + newDate);
                    if ($("input[name=rxsprocrss]:checked").val() != "totalpaid" && dnodename == "PBM" && dnodeval == "HD") {
                        var LocalHDType = localStorage.getItem('Updated_HD_Type_API');
                        localStorage.setItem('Prev_HD_Type_API', LocalHDType);
                        localStorage.setItem('Updated_HD_Type_API', 'totalpaid');
                        let newDate = new Date();
                        localStorage.setItem('Filter_Last_Update_Time_API', newDate);
                        PubSub.publish('PBM', 'HD')
                    }
                    this.props.handlechangea(e);
                }
                catch (error) {
                }
            }
            catch (error) {
            }
        } catch (error) {
        }
    }
    HandleResetButton = e => {
        try {
            PubSub.publish('PBM', 'HD')
            $("span." + "filtered_tag_dashboard").hide();
            $('button[class="reset-btn"]').css('display', 'none');
            this.setState({ loading: false });
            var CreatedJson = '';
            let ExistJson = JSON.parse(localStorage.getItem('Advance_Filter_API'));
            CreatedJson = JSON.stringify(ExistJson);
            localStorage.setItem('Advance_Filter_API', null);
            let newDate = new Date();
            localStorage.setItem('Filter_Last_Update_Time_API', newDate);
            localStorage.setItem('Updated_AdFilter_Status_API', CreatedJson + newDate);

            var LocalHDType = localStorage.getItem('Updated_HD_Type_API');
            localStorage.setItem('Prev_HD_Type_API', LocalHDType);
            localStorage.setItem('Updated_HD_Type_API', 'totalpaid');
            let newDate1 = new Date();
            localStorage.setItem('Filter_Last_Update_Time_API', newDate1);
            this.props.handlechangea(e);
        }
        catch (error) {
        }
    }

    GetTagTypeFullName(stext) {
        if (stext == 'WholesalerName') {
            return 'Wholesaler';
        }
        else if (stext == 'EndpointName' || stext == 'api endpoint') {
            return 'Endpoint Name';
        }
        else if (stext == 'EndpointGroup') {
            return 'Endpoint Group';
        }
        else if (stext == 'APIVersion') {
            return 'API version'
        }
        else { return 'Other'; }
    }
    render() {
        let s2 = this.state.FilterTagList;
        let s3 = this.state.FilterTagList.propertyIsEnumerable.length
        let icount = 0;
        Object.keys(this.state.FilterTagList).map((key, index) => {
            icount = icount + 1;
        })
        if (icount > 0) {
            return (
                <div className='filtered_tag_selected tag-available'>
                    {
                        this.state.FilterTagList != null ?
                            <div className="filtered_content">
                                <div className="filtered_adjust">
                                    {
                                        Object.keys(this.state.FilterTagList).map((key, index) => {
                                            try {
                                                let act = '';
                                                if (this.state.FilterMatchedTagList.filter((d) => d["tableType"] == key).length > 0) {
                                                    let KeyValue = this.state.FilterMatchedTagList.filter(function (m1) {
                                                        return m1.tableType == key
                                                    });
                                                    try {
                                                        return (
                                                            KeyValue.map((k1, ik) => {
                                                                try {
                                                                    if (k1.hasData == "True") {
                                                                        act = 'filtered_tag_dashboard active'
                                                                    }
                                                                    else {
                                                                        act = 'filtered_tag_dashboard';
                                                                    }
                                                                    return (
                                                                        <span id={key.replace(' ', '') + k1.value.replace(' ', '')} className={act} nodename={key} nodevalue={k1.value}>{this.GetTagTypeFullName(key) + '-' + k1.value}<label onClick={this.HandleRemoveTag}></label></span>
                                                                    )
                                                                } catch (error) {
                                                                }
                                                            })
                                                        )
                                                    }
                                                    catch (error) {
                                                    }
                                                }
                                                else {
                                                    return (
                                                        this.state.FilterTagList[key].map((e1, i1) => {
                                                            return (
                                                                <span myid={i1} id={key.replace(' ', '') + e1.replace(' ', '')} className='filtered_tag_dashboard' nodename={key} nodevalue={e1}>{this.GetTagTypeFullName(key) + '-' + e1}<label onClick={this.HandleRemoveTag}></label></span>
                                                            )
                                                        })
                                                    )
                                                }
                                            }
                                            catch (error) {
                                            }
                                        })
                                    }
                                </div>
                                {
                                    s2.propertyIsEnumerable.length > 0 && s3 > 0 ?
                                        <button className="reset-btn" onClick={this.HandleResetButton}>Reset</button> : null
                                }
                            </div>
                            : null
                    }
                </div>
            )
        }
        else {
            let LocalFilterJson = JSON.parse(localStorage.getItem('Advance_Filter_API'));
            if (LocalFilterJson != null && LocalFilterJson.propertyIsEnumerable.length > 0) {
                return (
                    <div className='filtered_tag_selected tag-available'>
                        {
                            <div className="filtered_content">
                                <div className="filtered_adjust">
                                    {
                                        Object.keys(LocalFilterJson).map((key, index) => {
                                            return (
                                                LocalFilterJson[key].map((e1, i1) => {
                                                    return (
                                                        <span id={key.replace(' ', '') + e1.replace(' ', '')} className='filtered_tag_dashboard' nodename={key} nodevalue={e1}>{this.GetTagTypeFullName(key) + '-' + e1}<label onClick={this.HandleRemoveTag}></label></span>
                                                    )
                                                })
                                            )
                                        })
                                    }
                                </div>
                                <button className="reset-btn" onClick={this.HandleResetButton}>Reset</button>
                            </div>
                        }
                    </div>
                )
            }
            else {
                return (
                    <div className='filtered_tag_selected'>
                        {
                            <div className="filtered_content">
                                <div className="filtered_adjust">
                                </div>
                            </div>
                        }
                    </div>
                )
            }
        }

    }

}
export default FilterTag_API;